import { Donuz } from "@/donuz-js/Donuz";
// @ is an alias to /src
export default {
  name: "contct",
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      contact: {
        subject: "",
        message: ""
      }
    };
  },
  methods: {
    submit: async function () {
      let msg = `<div style="background-color:#771b7c;padding:30px;">
                  <div style="width:650px;margin:auto;">
                    <div style="background-color:#fff;padding:20px;color:#333;">
                      <h3>${this.ESTABELECIMENTO.nome} - CONTATO</h3>
                      <p><strong>Nome:</strong> ${this.name} </p>
                      <p><strong>Email:</strong> ${this.email} </p>
                      <p><strong>Telefone:</strong> ${this.phone}</p>
                      <p><strong>Mensagem:</strong> ${this.contact.message}</p>
                    </div>
                   </div>
                 </div>`;
      let result = await Donuz.mail.sendMail({
        to: this.ESTABELECIMENTO.email,
        assunto: this.contact.subject,
        mensagem: msg
      }, this.ESTABELECIMENTO.id);

      if (result.status == 200) {
        this.$swal.fire({
          type: 'success',
          title: 'Sucesso!',
          text: "Mensagem enviada com sucesso!",
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        }).then(r => {
          location.reload()
        })
      } else {
        this.$swal.fire({
          title: 'Opss!',
          type: 'error',
          text: `Ouve um erro ao enviar a mensagem, entre em contato conosco através do número ${this.ESTABELECIMENTO.telefone}.`,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        }).then(r => {
          location.reload()
        })
      }
    }
  }
};
